<div class="footer">
    <div class="flex-box">
        <div class="box-3">
            <ul class="footer-logo">
                <li><img src="assets/images/evoca_logo.png" title="evoca_logo" alt="evoca_logo"
                        class="img-responsive-footer">
                </li>
                <li> {{ 'Footer.textAbout' | translate }}</li>
                <li>Copyright © 1990-{{year}} Evocabank</li>
            </ul>
        </div>
        <div class="box-3">
            <ul class="address">
                <li> {{ 'Footer.address' | translate }}</li>
            </ul>
        </div>
        <div class="box-3">
            <div>
                <ul class="contact-info">
                    <li><a href="mailto:hello@evoca.am" title="email">hello@evoca.am</a></li>
                    <li><a href="tel:+37410605555" title="+374 10 605555">+374 10 605555</a></li>

                </ul>
            </div>

        </div>
        <div class="box-3">
            <div>
                <img src="../../../assets/images/qr-evoca.png" alt="qr" class="qr-img" title="qr-img">
            </div>
        </div>
        <div class="box-3" align="right">
            <ul>
                <li>
                    <ul class="social">
                        <li>
                            <a title="facebook" href="https://www.facebook.com/evocabank/" target="_blank"><img
                                    class="img-responsive social-icons" title="facebook" alt="facebook"
                                    src="assets/images/social/facebook-gray.png"></a>
                        </li>
                        <li>
                            <a title="instagram" href="https://www.instagram.com/evocabank/" target="_blank"><img
                                    class="img-responsive social-icons" title="instagram" alt="instagram"
                                    src="assets/images/social/instagram-gray.png"></a>
                        </li>
                        <li>
                            <a title="youtube" href="https://www.youtube.com/channel/UCX1h31_vVfNdSATrEnWTWRA/videos"
                                target="_blank"><img class="img-responsive social-icons" title="youtube" alt="youtube"
                                    src="assets/images/social/youtube-gray.png"></a>
                        </li>
                        <li>
                            <a title="linkedin" href="https://www.linkedin.com/company/evocabank" target="_blank"><img
                                    class="img-responsive social-icons" title="linkedin" alt="linkedin"
                                    src="assets/images/social/linkedin-gray.png"></a>
                        </li>
                        <li>
                            <a title="pinterest" href="https://www.pinterest.com/evocabank/_created"
                                target="_blank"><img class="img-responsive social-icons" title="pinterest"
                                    alt="pinterest" src="assets/images/social/pinterest-gray.png"></a>
                        </li>
                    </ul>
                </li>
                <li>
                    <div>
                        <div style="float: right;"><a
                                href="https://play.google.com/store/apps/details?id=am.prometeybank.mobilebank&hl=ru&gl=US"
                                target="_blank">
                                <img src="https://resource.evoca.am/images/google_play_badge.png"
                                    style="width: 100px; margin: 5px;">
                            </a>
                        </div>
                        <div style="float: right;"><a href="https://apps.apple.com/ru/app/evocatouch/id970309076"
                                target="_blank">
                                <img src="https://resource.evoca.am/images/app_store_badge.png"
                                    style="width: 100px; margin: 5px;">
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="flex-box">
        <div class="box-7">
            <p class="text-align-justify">
                {{ 'Footer.aboutWeb' | translate }}
            </p>
        </div>
        <div class="box-5 footer-financial">
            <div>
                <a href="https://www.cba.am/" target="_blank"> <img class="img-responsive-financial"
                        src="../../../assets/images/cb.png" alt="cb"></a>
            </div>
            <div>
                <a href="https://www.fsm.am/" target="_blank"> <img class="img-responsive-financial"
                        src="../../../assets/images/financial_systen_mediator.png" alt="financial_systen_mediator"></a>
            </div>

            <div>
                <a href="https://www.abcfinance.am/" target="_blank"> <img class="img-responsive-financial"
                        src="../../../assets/images/abc_finance.png" alt="abc_finance"></a>
            </div>

            <div>
                <a href="https://adgf.am/" target="_blank"> <img class="img-responsive-financial"
                        src="../../../assets/images/deposit_guarantee.png" alt="deposit_guarantee"></a>
            </div>

            <div>
                <a href="https://cabinet.arca.am/hy/" target="_blank"> <img class="img-responsive-financial"
                        src="../../../assets/images/arca.png" alt="arca"></a>
            </div>
        </div>
    </div>
</div>



<div class="m-footer">
    <div class="flex-box">
        <div class="box-12">
            <img src="assets/images/evoca_logo.png" title="evoca_logo" alt="evoca_logo"
                class="img-responsive-footer m-logo">
        </div>
    </div>
    <div class="flex-box">
        <div class="box-6">
            <ul class="address">
                <li> {{ 'Footer.address' | translate }}</li>
            </ul>
        </div>
        <div class="box-6">
            <ul class="contact-info">
                <li><a href="mailto:hello@evoca.am" title="email">hello@evoca.am</a></li>
                <li><a href="tel:+37410605555" title="+374 10 605555">+374 10 605555</a></li>
            </ul>
        </div>
    </div>
    <div class="flex-box">
        <div class="box-12">
            <ul>
                <div class="m-social">
                    <li>
                        <a title="facebook" href="https://www.facebook.com/evocabank/" target="_blank"><img
                                class="img-responsive" title="facebook" alt="facebook"
                                src="assets/images/social/facebook-gray.png"></a>
                    </li>
                    <li>
                        <a title="instagram" href="https://www.instagram.com/evocabank/" target="_blank"><img
                                class="img-responsive" title="instagram" alt="instagram"
                                src="assets/images/social/instagram-gray.png"></a>
                    </li>
                    <li>
                        <a title="youtube" href="https://www.youtube.com/channel/UCX1h31_vVfNdSATrEnWTWRA/videos"
                            target="_blank"><img class="img-responsive" title="youtube" alt="youtube"
                                src="assets/images/social/youtube-gray.png"></a>
                    </li>
                    <li>
                        <a title="linkedin" href="https://www.linkedin.com/company/evocabank" target="_blank"><img
                                class="img-responsive" title="linkedin" alt="linkedin"
                                src="assets/images/social/linkedin-gray.png"></a>
                    </li>
                    <li>
                        <a title="pinterest" href="https://www.pinterest.com/evocabank/_created" target="_blank"><img
                                class="img-responsive social-icons" title="pinterest" alt="pinterest"
                                src="assets/images/social/pinterest-gray.png"></a>
                    </li>
                </div>
                <div>
                    <li>
                        <div style="display: flex;">
                            <div><a href="https://play.google.com/store/apps/details?id=am.prometeybank.mobilebank&hl=ru&gl=US"
                                    target="_blank"><img src="https://resource.evoca.am/images/google_play_badge.png"
                                        style="width: 100px; margin: 5px;" alt=""></a> </div>
                            <div><a href="https://apps.apple.com/ru/app/evocatouch/id970309076" target="_blank"> <img
                                        src="https://resource.evoca.am/images/app_store_badge.png"
                                        style="width: 100px; margin: 5px;" alt=""></a></div>
                        </div>
                    </li>
                </div>
            </ul>
        </div>
    </div>
    <div class="flex-box">
        <div class="box-12">
            <ul class="m-about">
                <li><b> {{ 'Footer.textAbout' | translate }}</b></li>
                <li>Copyright © 1990-{{year}} Evocabank</li>
            </ul>
        </div>
    </div>

</div>

<div class="m-footer-down">
    <div class="flex-box">
        <div class="box-12">
            <div class="footer-financial">
                <div>
                    <a href="https://www.cba.am/" target="_blank"> <img class="img-responsive-financial"
                            src="../../../assets/images/cb.png" alt="cb">
                    </a>
                </div>
                <div>

                    <a href="https://www.fsm.am/" target="_blank"> <img class="img-responsive-financial"
                            src="../../../assets/images/financial_systen_mediator.png" alt="financial_systen_mediator">
                    </a>
                </div>

                <div>
                    <a href="https://www.abcfinance.am/" target="_blank"> <img class="img-responsive-financial"
                            src="../../../assets/images/abc_finance.png" alt="abc_finance">
                    </a>
                </div>

                <div>
                    <a href="https://adgf.am/" target="_blank"> <img class="img-responsive-financial"
                            src="../../../assets/images/deposit_guarantee.png" alt="deposit_guarantee">
                    </a>
                </div>

                <div>
                    <a href="https://cabinet.arca.am/hy/" target="_blank"> <img class="img-responsive-financial"
                            src="../../../assets/images/arca.png" alt="arca">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="flex-box">
        <div class="box-12">
            <p class="text-align-justify">
                {{ 'Footer.aboutWeb' | translate }}
            </p>
        </div>
    </div>
</div>